/**
 * The project accent, for colours the tools draw themselves (canvas, map symbols, exported styles), where a CSS
 * `var()` cannot be used: read at use time from `--mm-accent` on the document, falling back to the product teal
 * (production's mmAccent, 14 Oct 2026). Styles that CSS draws say `var(--mm-accent, #27e3c4)` instead.
 */
export const ACCENT_FALLBACK = '#27e3c4';

const HEX = /^#[0-9a-f]{6}$/i;

export function accentHex(): string {
  try {
    if (typeof document === 'undefined' || typeof getComputedStyle === 'undefined') return ACCENT_FALLBACK;
    const v = getComputedStyle(document.documentElement).getPropertyValue('--mm-accent').trim();
    return HEX.test(v) ? v : ACCENT_FALLBACK;
  } catch {
    return ACCENT_FALLBACK;
  }
}

/** The accent at an opacity, as `rgba()`. */
export function accentRgba(a: number): string {
  const n = parseInt(accentHex().slice(1), 16);
  return `rgba(${(n >> 16) & 255},${(n >> 8) & 255},${n & 255},${a})`;
}
